import type { CityConfig } from "@/pages/city-template/types";

export const whitePlainsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "White Plains",
  state: "New York",
  stateAbbr: "NY",
  slug: "white-plains",
  route: "/cities/white-plains",
  title: "Emergency Passport White Plains, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription:
    "Emergency passport White Plains NY — same day, 24-hour, and 3-5 day expedited passport processing for Westchester County. Fast Passport Center serves White Plains, Harrison, Rye, Scarsdale, and all Westchester communities.",
  h1: "Emergency & Expedited Passport Services in White Plains, NY",
  heroSubtitle:
    "White Plains' fast passport solution — Westchester County's premier business hub. Whether you're flying out of Westchester County Airport or JFK, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days. A+ BBB rated, registered State Dept. courier. No office visit required.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20White%20Plains%20New%20York%20downtown%20skyline%20with%20modern%20office%20buildings%2C%20Westchester%20County%20Courthouse%2C%20suburban%20Westchester%20landscape%20in%20background%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20upscale%20New%20York%20suburban%20cityscape%20with%20tree-lined%20streets&width=1600&height=700&seq=ny-white-plains-hero-001&orientation=landscape",
  heroImageAlt: "White Plains New York downtown skyline with Westchester County buildings at golden hour",
  geoPosition: "41.0349; -73.7629",
  geoPlacename: "White Plains, New York, United States",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~28 miles (South in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "White Plains", zips: "10601, 10602, 10603, 10605, 10606, 10607, 10610" },
    { name: "Harrison", zips: "10528, 10577" },
    { name: "Rye", zips: "10580" },
    { name: "Scarsdale", zips: "10583" },
    { name: "New Rochelle", zips: "10801, 10802, 10804, 10805" },
    { name: "Yonkers", zips: "10701, 10703, 10704, 10705, 10706, 10707, 10708, 10709, 10710" },
    { name: "Mount Vernon", zips: "10550, 10551, 10552, 10553" },
    { name: "Greenwich (CT)", zips: "06830, 06831, 06836, 06870, 06878" },
    { name: "Stamford (CT)", zips: "06901, 06902, 06903, 06904, 06905, 06906, 06907, 06910, 06911, 06912, 06914, 06926, 06927" },
    { name: "Port Chester", zips: "10573" },
    { name: "Mamaroneck", zips: "10543, 10538" },
    { name: "Larchmont", zips: "10538" },
    { name: "Bronxville", zips: "10708" },
    { name: "Tuckahoe", zips: "10707" },
    { name: "Eastchester", zips: "10709" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for White Plains travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-building-2-line",
      title: "Westchester Corporate Ready",
      desc: "Fortune 500 companies, law firms, financial services — short-notice international business travel. We handle the passport so you handle the deal.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Westchester County",
      desc: "White Plains, Harrison, Rye, Scarsdale, and all of Westchester — we serve the entire county plus bordering Fairfield County, CT.",
    },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Mount Vernon", route: "/cities/mount-vernon" },
    { name: "Tarrytown", route: "/cities/tarrytown" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote:
    "Fast Passport Center serves White Plains and all of Westchester County as a remote courier service. We do not have a physical office in White Plains, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — White Plains area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to White Plains and all of Westchester County. From the downtown White Plains business district to the Sound Shore communities of Rye and Mamaroneck, from Scarsdale to Harrison — we serve Westchester County with the same fast, reliable processing that keeps this region's professionals and families traveling without interruption.",
  nearbyCitiesIntro:
    "We proudly serve White Plains and all surrounding communities across Westchester County and bordering Fairfield County, Connecticut. Whether you're in Harrison, Scarsdale, New Rochelle, or Greenwich, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our White Plains customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing. Most Westchester travelers complete everything online and ship documents overnight — the way busy professionals expect things to work.",
  mistakesIntro:
    "These are the most common mistakes White Plains travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "White Plains and Westchester County travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in White Plains. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
  servicesIntro: "Whether you need a renewal before a JFK flight to London, an emergency passport for a Westchester corporate deal closing in Frankfurt, or a first-time passport for a Scarsdale family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier, we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "JFK flight to London in two days? International deal closing in Frankfurt this week? Our emergency courier service submits via reserved agency slots — as fast as 24 hours for Westchester-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Westchester residents renew fast — no agency visit required for most renewals. Perfect for White Plains executives, Scarsdale families, and Harrison professionals preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide White Plains residents through every step — from downtown to Harrison to Rye — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your JFK connection or Westchester business trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Scarsdale family vacation or Westchester family trip abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Westchester professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Westchester corporate executives, consultants, and frequent business travelers whose primary passport is held in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Westchester-area travelers through the process so your international itinerary or corporate travel stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport White Plains NY", description: "Urgent passport processing for White Plains travelers with immediate departure needs from Westchester County Airport or JFK." },
    { name: "Expedited Passport Renewal White Plains NY", description: "Fast passport renewal for White Plains residents with a previously-issued passport." },
    { name: "First-Time Passport White Plains NY", description: "New passport application services for White Plains residents applying for their first passport." },
    { name: "Child Passport White Plains NY", description: "Minor passport services for Westchester families with children under 16." },
    { name: "Name Change Passport White Plains NY", description: "Passport name correction after marriage, divorce, or legal name changes for White Plains residents." },
    { name: "Second Passport White Plains NY", description: "Second passport services for Westchester corporate executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Richard M.",
      location: "Harrison, NY",
      rating: 5,
      text: "Had a last-minute business trip to London. Fast Passport Center got my expedited passport processed in 4 days. They coordinated with the acceptance clerk in White Plains seamlessly.",
      service: "Expedited Passport",
    },
    {
      name: "Sarah K.",
      location: "Scarsdale, NY",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center. Chose the 5-day option and had it back in 3. Excellent service for busy Westchester professionals who cannot afford downtime.",
      service: "Passport Renewal",
    },
    {
      name: "David L.",
      location: "Rye, NY",
      rating: 5,
      text: "First-time passport for my family vacation to Italy. The agent walked us through the entire process and found us a convenient acceptance facility in White Plains. Had everything in 5 days.",
      service: "New Passport",
    },
    {
      name: "Amanda W.",
      location: "Downtown White Plains",
      rating: 5,
      text: "Third time using Fast Passport Center for corporate travel to Frankfurt. They know the Westchester-to-JFK corridor and always deliver on time. My law firm's go-to for urgent passport needs.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "white-plains-1",
      name: "White Plains Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 Fisher Avenue",
      city: "White Plains",
      state: "NY",
      zip: "10601",
      phone: "(914) 761-6474",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Downtown White Plains",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Westchester passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person. Photo services available on-site. Book appointments 2+ weeks ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "white-plains-2",
      name: "Westchester County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "110 Dr Martin Luther King Jr Boulevard",
      city: "White Plains",
      state: "NY",
      zip: "10601",
      phone: "(914) 995-3080",
      hours: "Mon–Fri 9:00 AM – 5:00 PM",
      distance: "White Plains Government Center",
      website: "https://www.westchester.gov",
      websiteLabel: "Westchester County",
      notes: "Passport acceptance services available by appointment. Convenient for downtown White Plains residents and professionals. Limited Saturday hours may be available.",
      icon: "ri-government-line",
    },
    {
      id: "white-plains-3",
      name: "Mamaroneck Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "222 Boston Post Road",
      city: "Mamaroneck",
      state: "NY",
      zip: "10543",
      phone: "(914) 698-4800",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Mamaroneck (south of White Plains)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Mamaroneck, Larchmont, and south White Plains communities. Photo services available — call to confirm hours.",
      icon: "ri-mail-line",
    },
    {
      id: "white-plains-4",
      name: "Scarsdale Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "29 Chase Road",
      city: "Scarsdale",
      state: "NY",
      zip: "10583",
      phone: "(914) 723-6274",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Scarsdale (east of White Plains)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Scarsdale, Edgemont, and Greenacres residents. Appointment recommended during peak travel seasons. Photo services may be available.",
      icon: "ri-mail-line",
    },
    {
      id: "white-plains-5",
      name: "Rye Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "41 Purdy Avenue",
      city: "Rye",
      state: "NY",
      zip: "10580",
      phone: "(914) 967-3399",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Rye (southeast of White Plains)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serving Rye, Rye Brook, and Port Chester area. Limited appointment slots — book early for summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "white-plains-6",
      name: "Harrison Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "258 Harrison Avenue",
      city: "Harrison",
      state: "NY",
      zip: "10528",
      phone: "(914) 835-2646",
      hours: "Mon–Fri 9:00 AM – 5:00 PM",
      distance: "Harrison (northeast of White Plains)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance for Harrison and Purchase residents. Walk-ins subject to clerk availability. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to New York Passport Agency in Manhattan", fpc: "Most Westchester travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Westchester-Specific Guidance", agency: "Generic — no HPN/JFK airport or Westchester corporate travel expertise", fpc: "Full HPN/JFK Westchester corporate/university knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming HPN Has International Flights — It Does Not",
      description: "Westchester County Airport is domestic-only. Many White Plains travelers book international trips and do not realize they need to connect through JFK, creating a passport check requirement at the connecting hub. Always verify your full routing.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "White Plains applicants often attempt the simpler renewal form when their passport was issued at 15 or younger, or when the passport is significantly damaged. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Westchester pharmacies and big-box stores produce photos that fail State Department standards — wrong background shade, incorrect head size, or unacceptable expression. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Westchester families frequently overlook the DS-3053 consent form when one parent travels for work and cannot attend the acceptance appointment. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Validity Rule",
      description: "White Plains business travelers heading to London, Tokyo, or Singapore often do not realize their passport must have 6 months remaining beyond the return date. We flag this before it becomes a departure-day crisis.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your White Plains home, office, or on your commute." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your Westchester travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most White Plains clients ship from a UPS Store on Mamaroneck Avenue — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in White Plains?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for White Plains residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in White Plains?",
      a: "The White Plains Main Post Office at 100 Fisher Avenue is the major Westchester passport acceptance facility. The Westchester County Clerk at 110 Dr Martin Luther King Jr Boulevard also offers passport services by appointment. The Mamaroneck Post Office at 222 Boston Post Road is another convenient option for south White Plains residents.",
    },
    {
      q: "Can I get same-day passport photos in White Plains?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout White Plains and Westchester County including Harrison, Rye, and Scarsdale. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in White Plains?",
      a: "Government fees are set by the State Department: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees depend on processing speed and are typically 30-100% less than FedEx, Staples, and other third-party resellers. Call 877-253-0084 for a personalized quote based on your White Plains passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in White Plains?",
      a: "The fastest way to renew a passport in White Plains is through Fast Passport Center's 2-9 business day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in White Plains?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in White Plains and all Westchester County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in White Plains?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in White Plains. We serve Westchester County and all surrounding areas through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
    {
      q: "How do I check my Westchester passport application status?",
      a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from White Plains to final return shipping typically matches your chosen speed tier.",
    },
    {
      q: "Can you help with passports for JFK International Airport travel?",
      a: "Yes. JFK is one of the world's busiest international airports, and we regularly assist White Plains and Westchester travelers with expedited passports for JFK international departures. We understand the Westchester-to-JFK corridor — from Scarsdale to Harrison to Rye — and can coordinate timelines around your departure.",
    },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for White Plains & Westchester Residents",
    intro: "White Plains sits at the center of one of the wealthiest and most internationally-traveled counties in America. Westchester County's unique position — with its own regional airport (HPN) plus easy access to JFK and LaGuardia — creates distinct passport timing challenges for its corporate, university, and family travelers.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "HPN — Westchester County Airport",
        subtitle: "Westchester's own regional airport, domestic-only with hub connections",
        description: "HPN serves White Plains residents with flights to major U.S. hubs including Atlanta, Charlotte, Chicago, Detroit, and Washington DC. Many Westchester travelers use HPN for domestic connections to international gateways — but HPN itself has no international flights. This creates a hidden passport trap: you need valid documents at your connecting hub, not your departure airport. Corporate travelers rushing from downtown White Plains to HPN often overlook this.",
        tip: "If you connect through ATL, CLT, or ORD to fly internationally, your passport is checked at the connecting airport. Expired passports discovered mid-journey mean you miss your international flight and are stuck in a connecting city.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "JFK & LGA — The Manhattan Gateway Airports",
        subtitle: "JFK (international hub) at ~28 miles, LaGuardia (domestic) at ~22 miles",
        description: "JFK is the primary international airport for Westchester residents — British Airways, Emirates, Delta, and JetBlue all operate major international routes from JFK. White Plains executives routinely book JFK-LHR, JFK-CDG, and JFK-DXB for corporate travel. LaGuardia serves domestic connections. The drive from White Plains to JFK via the Hutchinson River Parkway typically takes 35-50 minutes, but rush hour can stretch to 90+. This creates a timing crunch for corporate travelers who discover passport issues the day before departure.",
        tip: "White Plains corporate travelers often book through company travel desks that do not flag passport expiration. Always self-check your passport validity, especially for any trip to a country requiring 6 months beyond return date — common for UK, EU, Japan, and UAE destinations.",
      },
      {
        icon: "ri-building-2-line",
        title: "Corporate Travel & Fortune 500 Demand",
        subtitle: "PepsiCo, IBM, Mastercard, Morgan Stanley, Point72, law firms, financial services",
        description: "White Plains and Westchester County host major corporate offices for Fortune 500 companies and global financial institutions. PepsiCo's global headquarters is in Purchase, IBM maintains major Westchester operations, and Mastercard's worldwide headquarters is nearby. White Plains is also home to dozens of top-tier law firms with international practices covering M&A, securities, and cross-border litigation. When corporate travel plans surface on short timelines — quarterly board meetings in London, M&A closings in Frankfurt, annual conferences in Tokyo — passport processing urgencies emerge that standard post office services cannot handle.",
        tip: "Westchester corporate travelers frequently need passports for deal-closing travel with 1-2 week notice. If your firm's travel desk does not track passport validity, check yours right now — especially if you travel to the UK, EU, or Asia where the 6-month validity rule applies.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "University & College Study Abroad",
        subtitle: "Pace University, Manhattanville College, Iona University, Purchase College",
        description: "Westchester County hosts Pace University (White Plains campus), Manhattanville College (Purchase), Iona University (New Rochelle), and SUNY Purchase — collectively sending thousands of students abroad each year for semester exchange, summer programs, and faculty-led trips. Many students — especially first-generation college students — have never held passports. The acceptance-to-orientation pipeline is often 6–10 weeks, requiring expedited processing to meet program start dates. Additionally, faculty members leading study-abroad programs sometimes discover their passport is expired just weeks before departure.",
        tip: "First-time applicants at Pace University, Manhattanville, or Iona must visit an acceptance facility in person. We guide Westchester students through the nearest facility with the earliest available appointment.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Westchester & Cross-Border Greenwich/Stamford Travel",
      description: "White Plains sits on the border of Fairfield County, Connecticut. Many Westchester residents work in Greenwich, Stamford, and Darien — and many Fairfield County residents use White Plains as their primary commercial center. This bi-state commuting pattern creates a unique passport urgency dynamic: travelers cross state lines daily for work but may not realize their passport is expired until an international trip is imminent.",
    },
  },
  destinations: {
    title: "Where Westchester Travelers Go — And Why Passports Get Urgent",
    intro: "White Plains and Westchester County's global corporate presence and affluent demographics mean travelers need passports for destinations spanning six continents. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "44%", label: "of White Plains expedited requests are corporate or business-related with under 2 weeks notice" },
      { stat: "2–3 Weeks", label: "average lead time Westchester travelers have from trip booking to international departure" },
      { stat: "Sep–Oct", label: "hidden peak when Q4 corporate travel, university study abroad, and holiday bookings collide" },
      { stat: "28 Hours", label: "shortest turnaround for a White Plains executive departing JFK to London" },
    ],
    destinations: [
      { name: "United Kingdom", context: "JFK-LHR direct flights, Wall Street and London financial corridor, law firm partnerships, Madison Avenue agencies with London offices", urgency: "Business trips booked 2–3 weeks out with fixed meeting dates — hard deadlines that cannot move", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "Fashion industry connections, Milan and Paris business travel, Westchester family heritage trips, summer villa vacations in Tuscany and Provence", urgency: "Summer bookings made 4–6 weeks out — but passports are often checked at the last minute", icon: "ri-map-pin-2-line" },
      { name: "Germany & Switzerland", context: "Frankfurt financial corridor, Zurich banking, pharmaceutical and biotech conferences, Swiss boarding school parents", urgency: "Industry conference dates are fixed and unmovable — passport issues discovered 1–2 weeks before", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Finance and tech deal travel, Tokyo conference season, Westchester-based Asian corporate headquarters connections", urgency: "Tech and finance travel often has 1–2 week booking-to-departure windows with strict 6-month validity rule", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Bahamas", context: "Winter escape travel, Westchester family resort vacations, cruise departures from New York and New Jersey terminals", urgency: "Last-minute resort deals and all-inclusive packages booked 3–4 weeks out during January–March peak", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Toronto and Montreal business travel, Westchester-Montreal family connections, ski trips to Quebec and Whistler", urgency: "Cross-border business bookings often 1–2 weeks out — travelers assume driver's license is enough until they check", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State and the Tri-State area with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "New York City", route: "/cities/new-york-city" },
      { name: "Yonkers", route: "/cities/yonkers" },
      { name: "Greenwich / Fairfield County", route: "/cities/greenwich" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — White Plains", address: "325 Mamaroneck Avenue, White Plains, NY 10605", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — White Plains", address: "1019 Mamaroneck Avenue, White Plains, NY 10605", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — White Plains", address: "222 Mamaroneck Avenue, White Plains, NY 10605", hours: "Mon–Fri 8 AM – 7 PM, Sat 9 AM – 5 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "FedEx Office — White Plains", address: "100 Main Street, White Plains, NY 10601", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "CVS Pharmacy — Scarsdale", address: "915 Central Park Avenue, Scarsdale, NY 10583", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Harrison", address: "261 Halstead Avenue, Harrison, NY 10528", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Rye", address: "1071 Boston Post Road, Rye, NY 10580", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walmart Photo Center — White Plains", address: "275 Main Street, White Plains, NY 10601", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — White Plains",
      address: "200 Hamilton Avenue, White Plains, NY 10601",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "White Plains DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Yonkers",
      address: "1 Larkin Plaza, Yonkers, NY 10701",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Yonkers DMV office serving south White Plains, Yonkers, and Mount Vernon residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NYS DMV — New Rochelle",
      address: "28 Huntington Avenue, New Rochelle, NY 10801",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "New Rochelle DMV office serving east White Plains, New Rochelle, and Mamaroneck communities. Appointments recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "HPN",
      name: "Westchester County Airport",
      distance: "~5 miles from White Plains",
      address: "240 Airport Road, White Plains, NY 10604",
      note: "Westchester's primary airport with flights to major U.S. hubs. Perfect for White Plains and Westchester County travelers connecting to international gateways.",
      flightUrl: "https://airport.westchestergov.com/",
      flightLabel: "HPN Airport",
      featured: true,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~28 miles from White Plains",
      address: "JFK Access Road, Jamaica, NY 11430",
      note: "Major international hub with flights worldwide. The closest major international airport for White Plains residents.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "~22 miles from White Plains",
      address: "Flushing, NY 11371",
      note: "Convenient for domestic flights and some international destinations. Popular alternative for Westchester County travelers.",
      flightUrl: "https://www.laguardiaairport.com/",
      flightLabel: "LGA Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records. Westchester County residents can also contact the Westchester County Clerk for local records.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NYS Department of Health Vital Records. Mail, online, and in-person options available.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Westchester County Clerk. Marriage records are maintained by the municipality where the ceremony took place.",
      url: "https://www.westchester.gov",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce decrees through the Westchester County Supreme Court Clerk. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default whitePlainsConfig;